import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import { Lang, UserAttrs, selectFilteredUsers, userSelector } from 'cdx-common';
import { useSelector } from 'react-redux';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { RootState } from '../../store';

type UserSelectInterface = SelectProps<ModelId> & {
    filter?: (user: UserAttrs) => boolean;
};

export const UserSelect = (props: UserSelectInterface) => {
    return <MainSimpleViewLoader
        path='user/list'>
        <LoadedUsers {...props} />
    </MainSimpleViewLoader>;
};

const LoadedUsers = (props: UserSelectInterface) => {

    const users = useSelector((state: RootState) => {
        return props.filter ? selectFilteredUsers(state, props.filter) : userSelector.selectAll(state);
    });

    return <FormControl fullWidth>
        <InputLabel>{props.label ?? Lang('selectUser')}</InputLabel>
        <Select
            {...props}
        >
            {users.map(user => <MenuItem value={user.id}>{user.name}</MenuItem>)}
        </Select>
    </FormControl>;
};
